export default __webpack_public_path__ + "static/media/hawk-orcadialabs.fcf93e32.png";